import { Screen } from './../Screen/Screen';
import { IScene } from './IScene';
export abstract class SceneBase implements IScene {
   
    
    background: string;
    image:string;
    x: number;
    y: number;
    w: number;
    h: number;

    paint(ctx) {        

        ctx.beginPath();
        ctx.fillStyle = 'rgb(0, 0, 0)';
        ctx.fillRect(0, 0, Screen.GetInstance().WIDTH, Screen.GetInstance().HEIGHT);        

    }

    update(dt){

    }

    onkeydown(keycode: number) {
        
    }
    onkeyup(keycode: number) {
        
    }

}


// WEBPACK FOOTER //
// D:/xamppabeel/htdocs/Angular2Projects/CanvasSVG/src/app/Scene/SceneBase.ts